/**
 * @generated SignedSource<<864ffae1b51eded95ef6b5f811051d20>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderOperation = "BUY" | "SELL";
export type OrderStatus = "ACCEPTED" | "CANCELED" | "CREATED" | "EXPIRED" | "FAILED" | "FINISHED";
export type OrdersInput = {
  assetId?: string | null | undefined;
  cursor?: string | null | undefined;
  dateEnd?: TimeScalar | null | undefined;
  dateStart?: TimeScalar | null | undefined;
  operation?: OrderOperation | null | undefined;
  size?: number | null | undefined;
  status?: OrderStatus | null | undefined;
};
export type TotalCountOrdersQuery$variables = {
  input?: OrdersInput | null | undefined;
};
export type TotalCountOrdersQuery$data = {
  readonly orders: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
};
export type TotalCountOrdersQuery = {
  response: TotalCountOrdersQuery$data;
  variables: TotalCountOrdersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "OrdersConnection",
    "kind": "LinkedField",
    "name": "orders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TotalCountOrdersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TotalCountOrdersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7eb3b9ef010e603556cfad72875afa24",
    "id": null,
    "metadata": {},
    "name": "TotalCountOrdersQuery",
    "operationKind": "query",
    "text": "query TotalCountOrdersQuery(\n  $input: OrdersInput\n) {\n  orders(input: $input) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "0074aa04f5f86769c60b14f88f4e9785";

export default node;
